import {
    SET_CONTEXT_UPDATERS,
    ADD_CONTEXT_UPDATER,
    REMOVE_CONTEXT_UPDATER,
    UPDATE_CONTEXT_UPDATER,
    ADD_UPDATER_CONTEXT_PROPERTY,
    REMOVE_UPDATER_CONTEXT_PROPERTY,
    UPDATE_UPDATER_CONTEXT_PROPERTY,
    SET_UPDATER_CONTEXT_PROPERTIES
} from "../actions/contextUpdaterActions";

export default function (state = [], action) {
    switch (action.type) {
        case SET_CONTEXT_UPDATERS:
            return action.contextUpdaters;
        case ADD_CONTEXT_UPDATER:
            return [...state, action.contextUpdater];
        case REMOVE_CONTEXT_UPDATER:
            return [...state.slice(0, action.index), ...state.slice(action.index + 1)];
        case UPDATE_CONTEXT_UPDATER:
            return [...state.map((updater, y) => {
                if (action.index === y) {
                    updater.data = {...updater.data, [action.property]: action.value};
                    return updater;
                }
                return updater;
            })];
        case ADD_UPDATER_CONTEXT_PROPERTY:
            return [...state.map(function (updater, y) {
                if (action.index === y) {
                    updater = {
                        ...updater,
                        data: {
                            ...updater.data,
                            contextProperties: [
                                ...updater.data.contextProperties,
                                action.contextProperty
                            ]
                        }
                    };
                    return updater;
                }
                return updater;
            })];
        case REMOVE_UPDATER_CONTEXT_PROPERTY:
            return [...state.map((updater, updaterOrder) => {
                if (action.updaterIndex === updaterOrder) {
                    updater = {
                        ...updater,
                        data: {
                            ...updater.data,
                            contextProperties: [
                                ...updater.data.contextProperties.slice(0, action.propertyIndex),
                                ...updater.data.contextProperties.slice(action.propertyIndex + 1)
                            ]
                        }
                    };
                    return updater;
                }
                return updater;
            })];
        case UPDATE_UPDATER_CONTEXT_PROPERTY:
            return [...state.map((updater, updaterOrder) => {
                if (action.updaterIndex === updaterOrder) {
                    updater = {
                        ...updater,
                        data: {
                            ...updater.data,
                            contextProperties: updater.data.contextProperties.map((contextProperty, propertyOrder) => {
                                if (action.propertyIndex === propertyOrder) {
                                    contextProperty = {...contextProperty, [action.property]: action.value};
                                    return contextProperty;
                                }
                                return contextProperty;
                            })
                        }
                    };
                    return updater;
                }
                return updater;
            })];
        case SET_UPDATER_CONTEXT_PROPERTIES:
            return [...state.map(function (updater, y) {
                if (action.updaterIndex === y) {
                    updater = {
                        ...updater,
                        data: {
                            ...updater.data,
                            contextProperties: action.contextProperties
                        }
                    };
                    return updater;
                }
                return updater;
            })];
        default:
            return state;
    }

}